import { Button, TextField, InputAdornment } from "@mui/material";
import { isWeb, maxLen } from "assets/js/common";
import { useForm } from "react-hook-form";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loadAction } from "redux/reducers/top";
import LazyCDNImage from "components/utils/lazy-cdn-image";
import AlertComplete from "components/ui/alert-complete";

export default function MyReviewDetail(props) {
  const dispatch = useDispatch();
  const history = useHistory();

  let { seq } = useParams();

  const [imgUrl, setImgUrl] = useState([]);
  const [detailData, setDetailData] = useState([]);
  const [alertMode, setAlertMode] = useState("");
  const [open, setOpen] = useState(false);
  const [length, setLength] = useState(0);

  const {
    register,
    handleSubmit,
    watch,
    control,
    setError,
    clearErrors,
    setValue,
    getValues,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      evSeq: "",
      cont: "",
      imgUrl1: "",
      imgUrl2: "",
      imgUrl3: "",
    },
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    setValue("pdTtl", history.location.props.pdTtl);
    setValue("prodImgUrl", history.location.props.prodImgUrl);
    watch("pdTtl", false);
    watch("prodImgUrl", false);
    if (history.location.props.seq) {
      loadDetail();
    } else {
      setValue("pdSeq", seq);
    }
  }, []);

  window.appBackKeyHandle = () => {
    if (open) {
      setOpen(false);
      if (alertMode == "modifyComp" || alertMode == "registComp") {
        history.goBack();
      }
    } else {
      history.goBack();
    }
  };

  const { init } = useSelector((state) => state.top);
  useEffect(() => {
    if (init)
      dispatch(loadAction({ back: true, title: "My 리뷰", menu: false }));
  }, [init]);

  const loadDetail = () => {
    axios.get(`/api/eh/product-review/get/${seq}`).then((res) => {
      // setDetailData(res.data.data.productReview);
      resetData(res.data.data.productReview);
    });
  };

  const resetData = (data) => {
    setValue("seq", data.seq);
    setValue("pdSeq", seq);
    setValue("cont", data.cont);
    setValue("imgUrl1", data.imgUrl1);
    setValue("imgUrl2", data.imgUrl2);
    setValue("imgUrl3", data.imgUrl3);
    watch("cont", false);
    watch("seq", false);

    let imgs = [data.imgUrl1, data.imgUrl2, data.imgUrl3];

    imgs = imgs.filter((element, i) => element != null);
    setImgUrl(imgs);
  };

  const onSubmit = (data) => {
    if (getValues("cont") && getValues("cont").length > 4) {
      handleComment();
    } else {
      handleAlertOpen("valid");
    }
  };

  const handleComment = () => {
    let form = watch("seq")
      ? {
          seq: getValues("seq"),
          pdSeq: getValues("pdSeq"),
          cont: getValues("cont"),
          imgUrl1: getValues("imgUrl1"),
          imgUrl2: getValues("imgUrl2"),
          imgUrl3: getValues("imgUrl3"),
        }
      : {
          pdSeq: getValues("pdSeq"),
          cont: getValues("cont"),
          imgUrl1: getValues("imgUrl1"),
          imgUrl2: getValues("imgUrl2"),
          imgUrl3: getValues("imgUrl3"),
        };

    imgUrl.map((item, i) => {
      form[`imgUrl${i + 1}`] = item;
    });

    axios
      .post(
        `/api/eh/product-review/${getValues("seq") ? "modify" : "regist"}`,
        form
      )
      .then((res) => {
        handleAlertOpen(`${getValues("seq") ? "modify" : "regist"}Comp`);
      });
  };

  const handleAlertOpen = (mode) => {
    setAlertMode(mode);
    setOpen(true);
  };

  const handleFileUpload = async (file) => {
    console.log("file", file);
    let formData = new FormData();
    formData.append("file", file);

    let result = "";
    await axios
      .post(`/api/st/s3/upload?domain=comment`, formData, {
        headers: {
          "Content-Type":
            "multipart/form-data; boundary=<calculated when request is sent>",
        },
      })
      .then((res) => {
        console.log("res.data.data", res.data.data);
        result = res.data.data;
      });
    return result;
  };

  const handleUploadImg = () => {
    if (imgUrl.length > 2) {
      setAlertMode("file");
      setOpen(true);
      return;
    }

    window.appUploadHandle2 = (id, url) => {
      setImgUrl([...imgUrl, url]);
    };

    location.href = `csrmegamart://upload?server=image&type=gallery&func=appUploadHandle2&wfunc=appUploadWrong&id=1`;
  };

  const handleWebFileUpload = async (e) => {
    const files = e.target.files;

    if (imgUrl.length + Object.keys(files).length > 3) {
      setAlertMode("file");
      setOpen(true);
      return;
    }
    let result = [];

    for (let file of files) {
      result.push(await handleFileUpload(file));
    }
    setImgUrl([...imgUrl, ...result]);
  };

  const handleAlertClose = () => {
    setOpen(false);
  };

  const handleImgDelete = (e, i) => {
    let urls = [...imgUrl];
    urls.splice(i, 1);
    setImgUrl(urls);
  };

  return (
    <div className="myReviewDetail">
      <div className="tit">
        <div className="main-img">
          <div className="img-wrap">
            <img src={getValues("prodImgUrl")} />
          </div>
        </div>
        <div className="prdc-tit">{getValues("pdTtl")}</div>
      </div>
      <div className="comment">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div
            className="input-section bg-grey"
            style={{ minHeight: "calc(100vh - 192px)" }}
          >
            <TextField
              //   label="Multiline"
              multiline
              placeholder="리뷰를 입력해주세요."
              variant="standard"
              inputProps={{
                maxLength: 200,
                style: { height: "100%", overflow: "scroll" },
              }}
              id="cont"
              {...register("cont")}
              onInput={(e) => {
                maxLen(e.target.value, 200);
                setLength(e.target.value.length);
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="bottom">
                    <span className="count">
                      {length}
                      /200
                    </span>
                  </InputAdornment>
                ),
              }}
              style={{ height: "310px" }}
            />
            {imgUrl.length > 0 && (
              <ul className="img-list">
                {imgUrl.map((item, i) => (
                  <li className="img-item" key={i}>
                    <LazyCDNImage
                      key={item}
                      cdnUrl={item}
                      style={{ width: "80px", height: "80px" }}
                    />
                    {/* <img src={`${process.env.PUBLIC_URL}/images/tiger.png`} /> */}
                    <Button
                      className="img-close"
                      onClick={(e) => {
                        handleImgDelete(e, i);
                      }}
                    >
                      <img
                        src={`${
                          process.env.PUBLIC_URL
                        }/images/icon/img-close.svg`}
                      />
                    </Button>
                  </li>
                ))}
              </ul>
            )}
            <div className="bottom-wrap">
              {isWeb ? (
                <Button
                  fullWidth
                  variant="outlined"
                  color="primary"
                  component="label"
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/images/icon/image.svg`}
                  />
                  사진첨부
                  <span className="cnt">{imgUrl.length}/3</span>
                  <input
                    type="file"
                    accept="image/*"
                    value=""
                    hidden
                    multiple
                    onChange={(e) => {
                      handleWebFileUpload(e);
                    }}
                  />
                </Button>
              ) : (
                <Button
                  fullWidth
                  variant="outlined"
                  color="primary"
                  onClick={handleUploadImg}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/images/icon/image.svg`}
                  />
                  사진첨부
                  <span className="cnt">{imgUrl.length}/3</span>
                </Button>
              )}
              <Button
                fullWidth
                variant="contained"
                color="primary"
                type="submit"
                style={{ marginLeft: 0 }}
              >
                {getValues("seq") ? "수정완료" : "등록하기"}
              </Button>
            </div>
          </div>
        </form>
      </div>

      {alertMode == "valid" ? (
        <>
          <AlertComplete
            open={open}
            handleAlertClose={handleAlertClose}
            text={"리뷰내용은 5자 이상 적어주세요. "}
            action={() => {
              handleAlertClose();
              document.querySelector("#cont").focus();
            }}
          />
        </>
      ) : alertMode == "registComp" ? (
        <>
          <AlertComplete
            open={open}
            handleAlertClose={handleAlertClose}
            text={
              "리뷰가 정상적으로 등록되었습니다. 100포인트가 지급되었습니다."
            }
            action={() => {
              handleAlertClose();
              history.goBack();
            }}
          />
        </>
      ) : alertMode == "modifyComp" ? (
        <>
          <AlertComplete
            open={open}
            handleAlertClose={handleAlertClose}
            text={"리뷰가 정상적으로 수정되었습니다."}
            action={() => {
              handleAlertClose();
              history.goBack();
            }}
          />
        </>
      ) : (
        <AlertComplete
          open={open}
          handleAlertClose={handleAlertClose}
          text={"이미지는 3개까지 첨부 가능합니다."}
          action={handleAlertClose}
        />
      )}
    </div>
  );
}
